module.exports = __webpack_public_path__ + "static/img/bar44@2x.ef4d8d16.png";